
/**
 * 
 */

import React, { useState, useEffect, useRef } from "react";
import { Trans, useTranslation } from "react-i18next";
import i18n from  "./../../Documental/Localization/i18n.js";
import ResultParser from  "./../../Documental/ResultParser/ResultParser.ts";
import { useNavigate, useParams } from 'react-router-dom';
import TopNav from "./../PatientApp/TopNav";
import MatrixSlide from "./MatrixSlide";
import ResultsPdf from  "./../../Documental/ResultsPdf/ResultsPdf.ts";
import { DomainResource } from './../../Documental/DomainResource/DomainResource';
// import CodingSystemTranslator from "./../../Documental/View/CodingSystemTranslator.js";
import SessionCookie from "./../../Documental/Utils/SessionCookie.js";

import StateMachine from 'react-simple-state/dist';
const appState = new StateMachine();



// const codingTranslator = new CodingSystemTranslator();

  /* {
      "extension": [
        {
          "url": "http://documental.ee/fhir/extension/request-group/action/problem",
          "valueCodeableConcept": {
            "coding": [
              {
                "system": "http://documental.ee/fhir/codesystem/problems/code",
                "code": "PROB10",
                "display": "Obsession-compulsion"
              }
            ]
          }
        }
      ],
      "priority": "urgent",
      "code": [
        {
          "coding": [
            {
              "system": "http://documental.ee/fhir/codesystem/request/code",
              "code": "GP",
              "display": "General practitioner consultancy is recommended"
            }
          ]
        }
      ]
    }
  */


/**
 * When yes- we don't show any services and redirect straifgt to rating page/finish
 * pre-appointment
 */
const isPreAppoinmentAssessment = () => {
    
  let currentMode = appState.getState( 'app-main-mode' );

  if( currentMode.appMainMode === "app-main-mode-free-assessment" ){
    return false;
  }
  
  if( currentMode.appMainMode === "app-main-mode-ukrainan" ){
    return false;
  }
  
  return true;
}


/**
 * When yes- we redirect to "user registration" page, and after that onto 
 * booking on ekliinik instead of simplybooks or rating page 
 * 
 */
const isFreeAssessment = () => {
    
  let currentMode = appState.getState( 'app-main-mode' );
  if( currentMode.appMainMode === "app-main-mode-free-assessment" ){
    return true;
  }
  return false;
}


const getPdfMetaInfos = () => {
  let metaInfos = [];

  const event = new Date();
  metaInfos.push( "Created DT: " + event.toLocaleString('et') );
  metaInfos.push( "Created UTC: " + event.toLocaleString('et', { timeZone: 'UTC' } ) );

  let items = window.appEntityStore.getAllResourcesBySearchParams({
    "resourceType" : "Patient"
  });
  for( var ii2 in items ){ // thereshould be only 1 patient resource in store
    let patientId = items[ ii2 ].getId();
    let pid = patientId.getResourceId();
    metaInfos.push( "PID: " + pid );
  }

  let items2 = window.appEntityStore.getAllResourcesBySearchParams({
    "resourceType" : "QuestionnaireResponse"
  });
  for( var ii3 in items2 ){ // thereshould be only 1 patient resource in store
    let qrId = items2[ ii3 ].getId();
    let id = qrId.getResourceId();
    metaInfos.push( "QR: " + id );
    
    let qrJson = items2[ ii3 ].toObject();
    if( typeof qrJson.encounter !== "undefined" &&  typeof qrJson.encounter.reference !== "undefined"  ){
      let t = qrJson.encounter.reference.split("Encounter/").join("");
      metaInfos.push( "E: " + t );
    }
  }
  
  var sessionCookie = new SessionCookie();
  const token = sessionCookie.readCookieValue("app-auth-token");
  metaInfos.push( "TKN: " + token );

  return metaInfos;
}

var timerResultsSendToServerPoll = null;

 
function Results( props ) {

  useEffect(() => {
    timerResultsSendToServerPoll = setInterval(() => {
      handleSaveSummaryPdf();
    }, 1000);
    return function(){
      if(timerResultsSendToServerPoll !== null){
        clearInterval(timerResultsSendToServerPoll);
        timerResultsSendToServerPoll = null;
      }
    }
  }, []);
 
  const navigate = useNavigate();
  let { id } = useParams();
  let guidanceResponseId = id;
  let pdfCreator = new ResultsPdf();
  var pdfSaved = false;
  
  const [ showDebug, setShowDebug ] = useState( false );
  let resultsParser = new ResultParser();
  
  var guidanceResponse = window.appEntityStore.getResourceById( guidanceResponseId );

  if( guidanceResponse === null ){
    //navigate( './../../../start' );
    //return null;
    return (
      <div>
        <div className="app-page results">
          <div className="page-inner">
            <TopNav />
            Results not found
          </div>
        </div>
      </div>
    );
    /**
    */
  }
   

  let guidanceResponseJson = guidanceResponse.toObject();
  let requestGroupId = guidanceResponseJson.result.reference.split("RequestGroup/").join("");
  
  var resultsResource = window.appEntityStore.getResourceById( requestGroupId );
  var resultsActions = [];
  if( !resultsResource || resultsResource == null ){
    console.log('Error loading results');
  } else {
    resultsParser.loadByRequestGroupResource( resultsResource );
    
    // add some meta info
    let metaInfos = getPdfMetaInfos();

    pdfCreator.generateBasedOnResults( resultsParser, metaInfos );
    pdfSaved = false;

    /**
    let resourceJson = resultsResource.toObject();
    console.log( resourceJson );

    for( var i in resourceJson.action ){
      let item = createMatrixItemFromAction( resourceJson.action[ i ] );
      if( item !== null ){
        resultsActions.push( item );
      }
    }
    */

    /* 
    for( var i in resourceJson.action ){
      let actionJson = resourceJson.action[ i ];
      if(
        typeof actionJson.extension === 'undefined' || 
        typeof actionJson.extension[ 0 ] === 'undefined'
      ){
        if(
            typeof actionJson.code !== 'undefined' && 
            typeof actionJson.code[ 0 ] !== 'undefined' && 
            typeof actionJson.code[ 0 ].coding !== 'undefined' && 
            typeof actionJson.code[ 0 ].coding[ 0 ] !== 'undefined' && 
            typeof actionJson.code[ 0 ].coding[ 0 ].code !== 'undefined'
        ){
          mainResult.code = actionJson.code[ 0 ].coding[ 0 ].code;
          mainResult.system = actionJson.code[ 0 ].coding[ 0 ].system;
          mainResult.display = actionJson.code[ 0 ].coding[ 0 ].display;

          mainResult.serviceRequestId = actionJson.resource.reference.split("ServiceRequest/").join("");
          
          if( mainResult.code && mainResult.system ){
            let t = codingTranslator.getTranslatedDisplayForCodeAndCurentLanguage( mainResult.system, mainResult.code );
            if( t ){
              mainResult.display = t;
            }
          }
        }
      }
      
    }
    */
  }
  

  resultsActions = resultsParser.getMatrixItems();
  let mainResult = resultsParser.getDecision();

  mainResult.finalSuggestionTitle = mainResult.display;

  mainResult.finalSuggestionRedirectToEkliinik = false;
  mainResult.finalSuggestionEkliinikLink = "";
  
  if( 
    mainResult.code === "" ||
    mainResult.code === "GR" ||
    mainResult.code === 'GY' 
  ){
    mainResult.finalSuggestion = 'all-good';
    mainResult.finalSuggestionTitle = i18n.t("In our opinion, you do not need a consultation with a mental health professional.");
    mainResult.finalSuggestionText = "";
  } else {
    mainResult.finalSuggestion = 'consultation';
    mainResult.finalSuggestionText = i18n.t("We offer the opportunity for a free video consultation. You will find more information after starting the process of booking");
    
    if( mainResult.code === "PT" || mainResult.code === "GP" ){
      mainResult.finalServiceProvider = 'psychologist';
      mainResult.finalSuggestionTitle = i18n.t("We recommend a consultation with a psychologist");
    } else {
      mainResult.finalServiceProvider = 'psychiatrist'; // PS ja ER
      mainResult.finalSuggestionTitle = i18n.t("We recommend a consultation with a psychiatrist");
    }
    
    // Temporary overwrite
    if( isFreeAssessment() ){
      mainResult.finalSuggestionTitle = i18n.t("We recommend a psychiatric consultation.");
    }
    
    // Teporary hardcoded booking urls for app mode free-assessment
    // Psühholoog -> lühike visiit https://connectedserver.eu/ConnectedOnlineX/default.aspx?key=PQD5CIDB&lang=et 
    // Psühhiaater -> pikk visiit https://connectedserver.eu/ConnectedOnlineX/default.aspx?key=6QON32R8&lang=et
    if( isFreeAssessment() ){
      mainResult.finalSuggestionRedirectToEkliinik = true;
      if( mainResult.finalServiceProvider === 'psychologist' ){
        mainResult.finalSuggestionEkliinikLink = "https://connectedserver.eu/ConnectedOnlineX/default.aspx?key=PQD5CIDB&lang=et";
      }
      if( mainResult.finalServiceProvider === 'psychiatrist' ){
        mainResult.finalSuggestionEkliinikLink = "https://connectedserver.eu/ConnectedOnlineX/default.aspx?key=6QON32R8&lang=et";
      }
    }
  }
  
  mainResult.acknowledgeExtraInfoStep = {
    show : false,
    text : ''
  }

  window.mainResult = mainResult;

  const handlePdfDownloadClick = () => {
    if( !pdfCreator.hasPdfGenerated() ){
      return false;
    }
    
    /*
    let base64 = pdfCreator.getBase64Encoded();

    const linkSource = "data:application/pdf;base64," + base64;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = "self-report.pdf";
    downloadLink.click();

    */

    pdfCreator.download();

    // const doc = pdfMake.createPdf(docDefinition); doc.getBase64((data) => { window.location.href = 'data:application/pdf;base64,' + data; });
    // data:application/pdf;base64,DATAHERE
    /// Android uses document.location whereas iOS supports window.location.replace therefore window.top.location.href you are using is not working.

    /** 
     * This solution di not work very well. opened with string showing in window
    var w = window.open('about:blank');
    var base64 = pdfCreator.getBase64Encoded();
    
    // FireFox seems to require a setTimeout for this to work.
    setTimeout(() => {
      w.document.body.appendChild(w.document.createElement('iframe')).src = "data:application/pdf;base64," + base64;
      w.document.body.style.margin = 0;
      w.document.getElementsByTagName("iframe")[0].style.width = '100%';
      w.document.getElementsByTagName("iframe")[0].style.height = '100%';
      w.document.getElementsByTagName("iframe")[0].style.border = 0;
    }, 0);
    */

    // Save to patient profile if current version not yet saved
    createResource();

    return false;
  }

  
  const handleSaveSummaryPdf = () => {
    if( !pdfCreator.hasPdfGenerated() ){
      return false;
    }

    // Save to patient profile if current version not yet saved
    createResource();

    if(timerResultsSendToServerPoll !== null){
      clearInterval(timerResultsSendToServerPoll);
      timerResultsSendToServerPoll = null;
    }

    return false;
  }


  /**
   * 
   * 
   * @return void
   */
  const createResource = () => {
    
    if( pdfSaved ){
      return;
    }

    pdfSaved = true;

    let items = window.appEntityStore.getAllResourcesBySearchParams({
      "resourceType" : "Patient"
    });
    
    // thereshould be only 1 patient resource in store
    let patientReferenceObj = {};
    for( var ii in items ){
      let patientId = items[ ii ].getId();
      let pid = patientId.getResourceId();
      
      patientReferenceObj = {
        "reference" : "Patient/" + pid
      }
    }
    
    // var encounterReferenceObj = window.encounterState.getGlobalEncounterJsonForResource();
    // get currently active Encounter extracted from QuestionnaireResponse given by server
    // there should be only 1 QuestionnaireResponse resource in store
    // also accessible from current Questionnaire info window.qHolder.responseResourceId.getResourceId()
    let encounterReferenceObj = {};
    let items2 = window.appEntityStore.getAllResourcesBySearchParams({
      "resourceType" : "QuestionnaireResponse"
    });
    for( var ii in items2 ){
      let qrJson = items2[ ii ].toObject();
      if( typeof qrJson.encounter !== "undefined" &&  typeof qrJson.encounter.reference !== "undefined"  ){
        encounterReferenceObj = {
          "reference" : qrJson.encounter.reference
        };
      }
    }

    let resId = window.appEntityStore.createLocalResourceId( 'DocumentReference' );
    var docManifest = new DomainResource( "DocumentReference" );
    
    let json = {
      'resourceType' : 'DocumentReference',
      // " date": "2022-12-25T23:50:50-05:00",
      'id' : resId,
      "language" : i18n.language,
      'status' : 'current',
      "description" : "DM patient summary",
      "author": [
        patientReferenceObj
      ],
      'subject' : patientReferenceObj,
      "content": [
        {
          "attachment": {
            "contentType": "application/pdf+base64", // application/binary  application/base64
            "language": i18n.language,
            "data" : pdfCreator.getBase64Encoded(),
            "title": "DM patient summary",
            // "url": "http://localhost:9556/svc/fhir/Binary/1e404af3-077f-4bee-b7a6-a9be97e1ce32",
            // "creation": "2005-12-24"
          }
        }
      ],
      "context": {
        "encounter": [
          encounterReferenceObj
        ]
      }
    };

    //  custodian		0..1	Reference(Organization)	Organization which maintains the document

    docManifest.setRawResourceObject( json );
    docManifest.setId( resId );
    
    docManifest.setResourceMeta( window.appEntityStore.getResourceMetaWithOnlyNewSourceUrl( 'DocumentReference' ) );
    
    window.appEntityStore.saveResource( docManifest );

    console.log( docManifest );
    console.log( docManifest.toObject() );

    return true;
  }
  
  const handleProceedClick = () => {
    navigate( './../../../booking' );
    return false;
  }

  const handleDebugClick = function() {
    return false;
    if( showDebug ){
      setShowDebug( false );
    } else {
      setShowDebug( true );
      navigator.clipboard.writeText( getDebugContent() );
    }
  }

  const getDebugContent = function() {
    let content = '---';
    
    // get latest GuidanceResponse
    
    if( window.appLastGuidaneResesponse2.hasRecievedGR && !window.appLastGuidaneResesponse2.isWaiting ){
      // guidanceResponseId
      var resultsResource2 = window.appEntityStore.getResourceById( window.appLastGuidaneResesponse2.guidanceResponseId );
      if( !resultsResource2 || resultsResource2 == null ){
        // 
      } else {
        content = "QRID:" + window.qHolder.responseResourceId.getResourceId() + "\n\n";
        console.log( window.qHolder.responseResourceId.getResourceId() );
        let resourceJson2 = resultsResource2.toObject();
        if(
          typeof resourceJson2.note !== 'undefined' && 
          typeof resourceJson2.note[ 0 ] !== 'undefined' 
        ){
          content = content + resourceJson2.note[ 0 ].text;
        }
      }
    } else {

    }

    return content;
  }


  const handlFinishClick = () => {
    navigate( './../../../rate' );
    return false;
  }

  /*
    Level(code=PROB10, outcome=GP)
    Level(code=PROB01, outcome=GP)
    Level(code=PROB05, outcome=GP)
    Level(code=PROB09, outcome=GP)
    Level(code=PROB11, outcome=GP)
    Level(code=PROB07, outcome=GP)
    Level(code=PROB14, outcome=GP)
    Level(code=PROB06, outcome=GP)
    Level(code=PROB04, outcome=GP)
    Level(code=PROB12, outcome=ER)
    Level(code=PROB08, outcome=GP)
    Level(code=PROB15, outcome=GP)
    Level(code=PROB02, outcome=GP)
    Level(code=PROB13, outcome=GP)
    Level(code=PROB03, outcome=GP)
    Level(code=PROB16, outcome=GY)

    Triage(outcome=ER)

    GY(2, "Not enough data for triage", RequestPriority.NULL), 
    GR(3, "No action is suggested", RequestPriority.ROUTINE),
    GP(1, "General practitioner consultancy is recommended", RequestPriority.URGENT),
    PT(4, "Psychotherapy is recommended", RequestPriority.URGENT),
    PS(5, "Psychiatric consultation is recommended", RequestPriority.ASAP),
    ER(6, "Emergency care is recommended", RequestPriority.STAT);

    PROB01("Mood"), 
    ....
    PROB16("Sexual activity")

    code: "GR"
    display: "No action is suggested"
    system: "http://documental.ee/fhir/codesystem/request/code"
  */
  
  let buttonProceedClasses = "btn full-width  dark ";
  let currentDebugContent = getDebugContent();
  let pdfHasGenerated = pdfCreator.hasPdfGenerated();
  
  let showServices = true;

  if( isPreAppoinmentAssessment() ){
    showServices = false;
  }

  let isFreeAssessmentResult = isFreeAssessment();
  let showPdfDownloadTextBelowMatrix = true;
  let isFreeAssessmentCTText = "";
  let finalSuggestionTitle1  = "";
  
  if( isFreeAssessmentResult ){
    showPdfDownloadTextBelowMatrix = false;

    isFreeAssessmentCTText = "";
    if( mainResult.finalServiceProvider === "psychologist" ){
      isFreeAssessmentCTText = i18n.t("I would like to book a 30-minute video consultation.");
      finalSuggestionTitle1  = i18n.t("Moderate mental health deteriorations are identified.");
    }
    if( mainResult.finalServiceProvider === "psychiatrist" ){
      isFreeAssessmentCTText = i18n.t("I would like to book a 45-minute video consultation.");
      finalSuggestionTitle1  = i18n.t("Significant mental health deteriorations are identified.");
    }
  }
  return (
    <div>
      <div className="app-page results">
        <div className="page-inner">
          <TopNav />
          
          {( !isFreeAssessmentResult ) && (
          <h1 className="mb-8" onClick={ function(){ handleDebugClick(); } }>{mainResult.finalSuggestionTitle}</h1>
          )}
          
          {( isFreeAssessmentResult ) && (
            <h1 className="mb-8 h1-free-assessment">{finalSuggestionTitle1}<span>{mainResult.finalSuggestionTitle}</span></h1>
          )}

          {( resultsActions.length > 0 ) && (
            <MatrixSlide 
              items={resultsActions} 
              pdfHasGenerated={pdfHasGenerated}
              onPdfDownloadClick={handlePdfDownloadClick}
            />
          )}
          
          <div className="mt-4">
            {/* mainResult.finalSuggestionText*/} 
            
            {( pdfHasGenerated && showPdfDownloadTextBelowMatrix ) && (
              <div>
                {( i18n.language === "et" ) && (
                  <div>
                    Kui soovid pöörduda oma valitud spetsialisti poole lae alla tulemuste kokkuvõte .pdf failina <a href="#/" className="link"  onClick={handlePdfDownloadClick} >siit</a>.
                  </div>
                )}
                {( i18n.language === "ru" ) && (
                  <div>
                    Вы можете получить обзор результатов в виде pdf-документа <a href="#/" className="link"  onClick={handlePdfDownloadClick} >здесь</a>.
                  </div>
                )}
                {( i18n.language === "uk" ) && (
                  <div>
                    Ви можете отримати огляд результатів у вигляді pdf-документа <a href="#/" className="link"  onClick={handlePdfDownloadClick} >тут</a>.
                  </div>
                )}
                {( i18n.language === "en" ) && (
                  <div>
                    You can get a summary of the results as a pdf document <a href="#/"  className="link"  onClick={handlePdfDownloadClick} >here</a>.
                  </div>
                )}
              </div>
            )}


            {( showServices && !isFreeAssessmentResult && mainResult.finalSuggestion !== "all-good" ) && (
              <div className="results-big-question mt-4"><Trans>Would you like to book a free 30 minutes video consultation?</Trans></div>
            )}

            {( isFreeAssessmentResult && mainResult.finalSuggestion !== "all-good" ) && (
              <div className="results-big-question results-big-question-free-assessment mt-4">{isFreeAssessmentCTText}</div>
            )}
          </div>
          
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
        
        
        {( showServices && mainResult.finalSuggestion !== "all-good" ) && (
          <div className="app-fragment pull-bottom-fixed pull-bottom-gradient">
            <div className="grid gap-4 grid-cols-2  mb-6">
              <span className="btn full-width dark disabled" onClick={handlFinishClick}><Trans>No</Trans></span>
              <span className={buttonProceedClasses} onClick={handleProceedClick}><Trans>Yes</Trans></span>
            </div>
          </div>
        )}

        {( mainResult.finalSuggestion === "all-good" ) && (
          <div className="app-fragment pull-bottom-fixed pull-bottom-gradient">
            <span className="btn dark full-width mb-6" onClick={handlFinishClick}>
              <Trans>Next</Trans>
            </span>
          </div>
        )}

        {( !showServices && mainResult.finalSuggestion !== "all-good" ) && (
          <div className="app-fragment pull-bottom-fixed pull-bottom-gradient">
            <span className="btn dark full-width mb-6" onClick={handlFinishClick}>
              <Trans>Finish</Trans>
            </span>
          </div>
        )}

        {( showDebug ) && (
          <textarea className="" value={currentDebugContent} style={{"position" : "absolute", "left" :"5%" , "bottom" : "0", "width" : "90%", "height":"60vh" }}></textarea>
        )}

      </div>
    </div>
  );
}
 
 
export default Results;
